import { List, ListItem, ListItemText, Paper } from "@mui/material";
import ProjectPositionDTO from "../../dto/ProjectPositionDTO";
import OpsPanel from "../OpsPanel";
import newFolder from "../../img/icons/new_folder.svg"

interface Props {
  projectPositions: ProjectPositionDTO[]
}

export const Positions = ({ projectPositions }: Props) => {

  return (
    <OpsPanel
      title="Project list / Positions"
      svg={newFolder}
    >
      <Paper elevation={0} style={{ minHeight: "15.5em", overflow: "auto" }}>
        <List disablePadding>
          {projectPositions.length ? (
            projectPositions?.map((projectPosition, index) => (
              <ListItemText
                key={index}
                primary={`${projectPosition.positionName}`}
                secondary={`${projectPosition.projectName}`}
                primaryTypographyProps={{ fontWeight: "bold", fontSize: '0.875rem' }}
              />
            ))
          ) : (
            <ListItem>
              <ListItemText primary="No data" />
            </ListItem>
          )}
        </List>
      </Paper>
    </OpsPanel>
  );
};
